import { navigateToUrl } from './../../common/helpers'
import { html, LitElement, property } from 'lit-element'
import { t } from '../../directives/translate'
import { getShellAnalytics, getShellApiInstance } from '../../common/shell-api-helpers'
import styles from './shell-landing.styles.scss'
import { nothing } from 'lit-html'
import { getInflightRequest } from '../../services/auth/utils'

const iPhone = {
  type: 'iPhone',
  imageSrc: 'assets/mobileDownload/app-store-badge.svg',
  downloadUrl: 'https://apps.apple.com/us/app/goto/id1465614785',
}

const android = {
  type: 'Android',
  imageSrc: 'assets/mobileDownload/google-play-badge.png',
  downloadUrl: 'https://play.google.com/store/apps/details?id=com.logmein.gotoconnect&pli=1',
}

export class ShellLanding extends LitElement {
  static readonly tagName = 'goto-shell-landing'
  @property({ type: Boolean }) isMobileUser = false
  @property({ type: String }) userAgent = ''

  static get styles() {
    return styles
  }

  connectedCallback() {
    super.connectedCallback()
    this.checkIfMobileUser()
  }

  private checkIfMobileUser() {
    this.userAgent = navigator.userAgent
    if (this.isAndroidUser() || this.isIphoneUser()) {
      this.isMobileUser = true
    }
  }

  private isIphoneUser() {
    return /iPhone/.test(this.userAgent)
  }

  private isAndroidUser() {
    return /android/i.test(this.userAgent)
  }

  private login() {
    const inflightPathname = getInflightRequest() ?? '/'
    getShellApiInstance().auth.login({ inflightPathname })
  }

  private renderMobileAppDownloadPrompt() {
    return this.isMobileUser
      ? html`
          <chameleon-typography variant="body-large" class="download-description">
            ${t('Get the most out of GoTo on the mobile app.')}
          </chameleon-typography>
          ${this.renderDownloadBadge()}
        `
      : nothing
  }

  private handleDownloadMobileAppClick() {
    const mobileOSInfo = this.getMobileOSInfo()
    getShellAnalytics().track('GoTo > Download Mobile', { action: 'click', device: mobileOSInfo.type })
    navigateToUrl(mobileOSInfo.downloadUrl)
  }

  private renderDownloadBadge() {
    return html` <a href=${this.getMobileOSInfo().downloadUrl} @click=${this.handleDownloadMobileAppClick}>
      <img class="download-badge-img" alt=${t('Download mobile app')} src=${this.getMobileOSInfo().imageSrc} />
    </a>`
  }

  private getMobileOSInfo() {
    return this.isIphoneUser() ? iPhone : android
  }

  render() {
    return html` <div class="landing-container">
      <div class="landing-content">
        <chameleon-goto-logo></chameleon-goto-logo>
        <chameleon-typography variant="heading-large" class="container-title">
          ${t('Tools to help you work together better')}
        </chameleon-typography>
        <chameleon-typography variant="body-large" class="container-description">
          ${t('Sign in to see your meetings and more or enter session ID or name to join a meeting.')}
        </chameleon-typography>
        <div class="user-action-container">
          <chameleon-button id="sign-in-to-goto" variant="primary" size="xlarge" @click=${this.login}>
            ${t('Sign in to GoTo')}
          </chameleon-button>
          <chameleon-typography variant="body-large" class="or-text">${t('Or')}</chameleon-typography>
          <goto-meeting-id-input></goto-meeting-id-input>
        </div>
        ${this.renderMobileAppDownloadPrompt()}
      </div>
    </div>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [ShellLanding.tagName]: ShellLanding
  }
}
